import React from 'react';
import {Box, Button, Paper, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

interface DownloadFileViewProps {
    titleKey: string;
    infoKey: string;
    defaultExtension: string;
    fileData: string | null;
    fileName?: string;
    fileExtension?: string;
    renderBackButton: () => React.ReactNode;
}

const DownloadFileView = ({
    titleKey,
    infoKey,
    defaultExtension,
    fileData,
    fileName,
    fileExtension,
    renderBackButton,
 }: DownloadFileViewProps) => {
    const { t } = useTranslation();

    const handleDownload = () => {
        if (!fileData) {
            return;
        }

        const a = document.createElement('a');
        a.href = fileData;
        a.download = fileName || `file.${fileExtension || defaultExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <Box sx={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2.5 }}>
                {renderBackButton()}
            </Box>

            <Paper variant="outlined" sx={{ borderRadius: '8px', padding: '40px', textAlign: 'center'}}>
                <Typography variant="h6" color="primary" sx={{ mb: 2 }}>
                    {t(titleKey)}
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                    {t(infoKey)}
                </Typography>

                <Button variant="contained" onClick={handleDownload} sx={{ mt: 2 }}>
                    {t('fileViewer.download')}
                </Button>
            </Paper>
        </Box>
    );
};

export default DownloadFileView;